/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

import type { BondIssuer } from '@/integrations/supabase/debt.models';

export type { BondIssuer };

export function useBondIssuers() {
  return useQuery({
    queryKey: ['bond_issuers'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('bond_issuers' as any)
        .select('*')
        .order('name', { ascending: true });
      if (error) throw error;
      return data as BondIssuer[];
    },
  });
}

export function useCreateBondIssuer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (issuer: Omit<BondIssuer, 'id' | 'created_at' | 'updated_at'>) => {
      const { data, error } = await supabase
        .from('bond_issuers' as any)
        .insert(issuer)
        .select()
        .single();
      if (error) throw error;
      return data as BondIssuer;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['bond_issuers'] }),
  });
}
